/** @jsx jsx */

import { omit } from 'lodash';

import { jsx, css } from '@emotion/core';

import CodeEditor from 'app/developer-v3/components/CodeEditor';
import { prettyFormatJsonString } from 'app/developer-v3/utils';

import { Wrapper } from '../Tab';

const Styles = {
  outputMessage: css`
    white-space: break-spaces;
    line-height: 1.3em;
  `,
};

type Output = {} | Object[];

type Props = {
  errorMessage?: string;
  onClickTestAgain: () => void;
  output: Output | null;
};

export const NO_OUTPUT_MESSAGE = 'No data payload in Response';

const clearZapData = (item: {}): {} => {
  const keysToRemove = Object.keys(item).filter(key =>
    key.startsWith('_zap_data_')
  );
  return omit(item, keysToRemove);
};

const clearZapDataFromOutput = (output: Output | null) => {
  if (!output) {
    return {};
  }

  return Array.isArray(output)
    ? output.map(clearZapData)
    : clearZapData(output);
};

function Response({ errorMessage, onClickTestAgain, output }: Props) {
  // APIs may not send a payload when testing auth,
  // in which case output will be null.
  // Output should never be undefined.
  const message = output === null ? NO_OUTPUT_MESSAGE : errorMessage;

  return (
    <Wrapper onClickTestAgain={onClickTestAgain}>
      {message ? (
        <div css={Styles.outputMessage}>{message}</div>
      ) : (
        <CodeEditor
          mode="javascript"
          value={prettyFormatJsonString(clearZapDataFromOutput(output))}
          width="100%"
        />
      )}
    </Wrapper>
  );
}

export default Response;
